import React from "react";
import { useState, useEffect } from 'react';
import {ReactComponent as Logo} from "./logo.svg";
import {ReactComponent as ArrowRight} from "./icons/ArrowRight.svg";
import {ReactComponent as Email} from "./icons/Message.svg";
import {ReactComponent as Instagram} from "./icons/Instagram.svg";
import {ReactComponent as Github} from "./icons/Github.svg";
import './App.css';
import CustomCursor from "./icons/CustomCursor";
import banner from "./images/poke.jpg";
import profilePic from "./images/profilePic.jpg";







function App() {



    // const text = "Hey there, my name's Daniel";
    // const [subIndex, setSubIndex] = useState(0);
    // const [deleting, setDeleting] = useState(false);
    //
    // useEffect(() => {
    //     const timeout = setTimeout(() => {
    //         if (!deleting && subIndex < text.length) {
    //             setSubIndex((prev) => prev + 1); // typing
    //         } else if (deleting && subIndex > 0) {
    //             setSubIndex((prev) => prev - 1); // deleting
    //         } else if (!deleting && subIndex === text.length) {
    //             setTimeout(() => setDeleting(true), 1000); // pause before deleting
    //         } else if (deleting && subIndex === 0) {
    //             setDeleting(false); // start typing again
    //         }
    //     }, deleting ? 50 : 150);
    //
    //     return () => clearTimeout(timeout);
    // }, [subIndex, deleting, text]);



    const gigArray = [
        "UI/UX Designer",
        "React JS Developer",
        "Mobile App Developer",
        "React Native Developer",
        "Frontend Developer"
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === gigArray.length - 1 ? 0 : prevIndex + 1
            );
        }, 2000);

        return () => clearInterval(intervalId);
    }, [gigArray.length]);

    return (
      <>
          <body>
          <CustomCursor/>
          <header>
              <div className='logoDiv'>
                  <h1>/</h1>
                  <Logo className='logoSVG'/>
              </div>
              <div className='utilities'>
                  <p>Templates</p>

                  <p>Pricing</p>


              </div>
          </header>
          <main>
              <section className='section1'>
                  <h1 className='directions'>
                      Scroll right  <ArrowRight className='section1Icon'/>
                      {/*{text.substring(0, subIndex)}*/}
                  </h1>
                  <h1 className='hello'>
                      Hey, my name's Daniel
                  </h1>
                  <img className='section1Img' src={banner} alt="banner"/>
                  <button className='employBtn'>
                      <span>Hire Me</span>
                      {/*<ArrowRight className='employBtnSVG'/>*/}
                  </button>


              </section>
              <section className='section2'>
                  <h1
                      key={currentIndex}
                      className="animated-text">
                      I am a {gigArray[currentIndex]}
                  </h1>
              </section>
              <section className='section3'>
                  <h1>About Me</h1>
                  <div className='section3Flex'>
                      <img  className='section3Img' src={profilePic} alt="profile" />

                      <div className='section3p'>
                                <span>
                                    I am a Frontend Developer specializing <br/>
                                    in Web and Mobile App development with expertise <br/>
                                    in React.js and React Native. I also bring <br/>
                                    strong UI/UX design skills, leveraging Figma <br/>
                                    to create intuitive and engaging user experiences.
                                </span>
                          <a className='email'
                             href="mailto:onuosad@gmail.com?subject=Hello there, Daniel&body=I%20want%20to%20hire%20you%20to%20build%20a%20website%20for%20me!"
                             target="_blank" rel="noopener noreferrer">
                              <Email className='emailIcon'/>
                              onuosad@gmail.com
                          </a>
                          <div className='connect'>
                              <a href='https://github.com/onuosa' target="_blank" rel="noopener noreferrer">
                                  <Github className='connectIcon'/>
                              </a>
                              <a href='https://instagram.com/onuosa_' target="_blank" rel="noopener noreferrer">
                                  <Instagram className='connectIcon'/>
                              </a>
                          </div>

                      </div>


                  </div>

              </section>

          </main>
          <footer>

          </footer>
          </body>

      </>
    );
}

export default App;
